import { render } from "./Internships.vue?vue&type=template&id=49b1d8df"
import script from "./Internships.vue?vue&type=script&lang=js"
export * from "./Internships.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__